<template>
  <ApexChart
    :type="chartType"
    :options="chartOptions"
    :series="value"
    width="100%"
    height="415px"
  />
</template>

<script>
export default {
  props: {
    value: {
      type: [ Array, Object ],
      required: true
    },
    chartType: {
      type: String,
      required: false,
      default: 'line'
    },
    chartOptions: {
      type: Object,
      required: false,
      default: () => ({})
    },
    title: {
      type: String,
      required: false,
      default: 'Title'
    }
  }
}
</script>
